/*
 * Launch countdown.
 *
 * The deadline arrives as a full ISO 8601 string with an explicit UTC offset
 * (built in Liquid from the merchant's date, time and timezone settings), so
 * every visitor counts down to the same moment no matter where they are.
 */
if (!customElements.get('hype-countdown')) {
  customElements.define(
    'hype-countdown',
    class HypeCountdown extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('.hype-countdown__grid');
        this.expired = this.querySelector('.hype-countdown__expired');
        this.deadline = Date.parse(this.dataset.deadline);

        // A malformed date would otherwise render "NaN" across the page.
        if (Number.isNaN(this.deadline)) {
          this.showExpired();
          return;
        }

        this.units = {
          days: this.querySelector('[data-unit="days"]'),
          hours: this.querySelector('[data-unit="hours"]'),
          minutes: this.querySelector('[data-unit="minutes"]'),
          seconds: this.querySelector('[data-unit="seconds"]')
        };

        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      tick() {
        const remaining = this.deadline - Date.now();

        if (remaining <= 0) {
          clearInterval(this.timer);
          this.showExpired();
          return;
        }

        const seconds = Math.floor(remaining / 1000);
        const values = {
          days: Math.floor(seconds / 86400),
          hours: Math.floor((seconds % 86400) / 3600),
          minutes: Math.floor((seconds % 3600) / 60),
          seconds: seconds % 60
        };

        Object.entries(values).forEach(([unit, value]) => {
          const node = this.units[unit];
          if (!node) return;
          // Days can run past 99 on a long pre-launch, so only pad the rest.
          const text = unit === 'days' ? String(value) : String(value).padStart(2, '0');
          if (node.textContent !== text) node.textContent = text;
        });

        if (this.grid) this.grid.hidden = false;
      }

      showExpired() {
        if (this.grid) this.grid.hidden = true;
        if (this.expired) this.expired.hidden = false;
        this.setAttribute('data-state', 'expired');
      }
    }
  );
}
